import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { requireMinRole } from "@/lib/route-guards";
import { DocumentLibraryPage } from "@/sections/documents/library/page";

interface DocumentsSearch {
  group?: string;
  q?: string;
}

export const Route = createFileRoute("/dashboard/documents/")({
  component: Component,
  beforeLoad: ({ context }) => {
    requireMinRole(context.session, "viewer");
  },
  staticData: {
    title: "Documents",
  },
  // The group and the query live in the URL so a filtered view is a link —
  // shareable, bookmarkable, and what the sidebar's nested entries point at.
  validateSearch: (search: Record<string, unknown>): DocumentsSearch => ({
    group: typeof search.group === "string" ? search.group : undefined,
    q: typeof search.q === "string" && search.q ? search.q : undefined,
  }),
});

function Component() {
  const { group, q } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <DocumentLibraryPage
      group={group}
      q={q}
      onGroupChange={(next) =>
        navigate({ search: (prev) => ({ ...prev, group: next }) })
      }
      onSearchCommit={(next) =>
        navigate({ search: (prev) => ({ ...prev, q: next }) })
      }
    />
  );
}
